
import { IGlobalState } from "@/store";
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "vue";
import { useStore } from "vuex";
import { useAppAuthedSchool } from "@/hooks/frontApp";
import { ISchool } from "@/typings/application";
import { useRouter } from "vue-router";
import { EXAMINE_STATE } from "@/typings/factory";
import selectSchool from "./modules/selectSchool.vue";
import { cancelAppSchool } from "@/service/api";
import { ElMessage } from "element-plus";

export default defineComponent({
  components: {
    selectSchool,
  },
  setup() {
    const store = useStore<IGlobalState>();
    const router = useRouter();
    const state = reactive({
      userId: computed(() => store.state.user.id),
      appId: router.currentRoute.value.query.appid,
      examineStateList: [
        {
          lable: "未审核",
          value: EXAMINE_STATE.NOEXAMINE,
        },
        {
          lable: "通过",
          value: EXAMINE_STATE.PASS,
        },
        {
          lable: "未通过",
          value: EXAMINE_STATE.NOPASS,
        },
        {
          lable: "全部状态",
          value: -1,
        },
      ],
      cancelDialogVisible: false,
      cancelAppSchoolId: "",
      clickModalClose: false,
      authTypeList: [
        {
          id: -1,
          name: "全部类型",
        },
        {
          id: 1,
          name: "学校",
        },
        {
          id: 2,
          name: "区平台",
        },
      ],
    });
    // 授权类型 1：学校；2：区平台
    const authType = computed({
      get: () => store.state.frontApp.authSchool.authType,
      set: (val) => {
        store.state.frontApp.authSchool.authType = val;
      },
    });
    // 获取关键字
    const keyWord = computed({
      get: () => store.state.frontApp.authSchool.keyWord,
      set: (val) => {
        store.state.frontApp.authSchool.keyWord = val;
      },
    });
    // 审核状态
    const examineState = computed({
      get: () => store.state.frontApp.authSchool.examineState,
      set: (val) => {
        store.state.frontApp.authSchool.examineState = val;
      },
    });
    // 已授权学校
    const authSchools = computed(() => store.state.frontApp.authSchool);

    // 获取当前页码数
    const page = computed({
      get: () => store.state.frontApp.authSchool.page,
      set: (val) => {
        store.state.frontApp.authSchool.page = val;
      },
    });
    // 授权窗口是否可见状态
    const visibleModal = ref(false);
    /**
     * 获取应用已授权学校列表
     */
    const getAuthSchools = async () => {
      await useAppAuthedSchool(
        store,
        state.userId,
        state.appId,
        examineState.value,
        keyWord.value,
        authType.value,
        page.value,
        authSchools.value.limit
      );
    };

    /**
     * 搜索
     */
    async function handleSearch() {
      page.value = 1;
      await getAuthSchools();
    }

    /**
     *复制学校id
     */
    function copySchoolId(row: ISchool) {
      var oInput = document.createElement("input");
      oInput.value = row.schoolId;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      ElMessage({ message: "复制成功", type: "success" });
      console.log("copy:" + row.schoolId);
    }

    /**
     * 点击取消授权
     */
    function wantCancelAuth(row: ISchool) {
      state.cancelAppSchoolId = row.id;
      state.cancelDialogVisible = true;
    }

    /**
     * 取消授权学校
     */
    async function cancelAuthSchool() {
      const params = {
        id: state.cancelAppSchoolId,
      };
      const result = await cancelAppSchool(params);
      if (result.code == 1) {
        ElMessage({ message: "取消授权成功", type: "success" });
        state.cancelDialogVisible = false;
        await getAuthSchools();
      } else {
        ElMessage({ message: result.msg, type: "error" });
      }
    }

    /**
     * 打开授权学校弹框
     */
    function openSelectSchool() {
      visibleModal.value = true;
    }

    /**
     * 关闭授权学校弹框
     */
    function closeModal() {
      visibleModal.value = false;
    }

    /**
     * 分页改变是回调方法
     */
    async function changePage(cueerntPage: number) {
      page.value = cueerntPage;
      await getAuthSchools();
    }

    /**
     * 页面一开始加载就调用厂商列表
     */
    onMounted(async () => {
      await getAuthSchools();
    });
    return {
      ...toRefs(state),
      keyWord,
      examineState,
      page,
      authSchools,
      getAuthSchools,
      visibleModal,
      handleSearch,
      cancelAuthSchool,
      openSelectSchool,
      closeModal,
      wantCancelAuth,
      changePage,
      copySchoolId,
      authType,
    };
  },
});
